import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5c1a7f8a = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _5511de74 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _5f130b8e = () => interopDefault(import('..\\pages\\have-a-card\\index.vue' /* webpackChunkName: "pages_have-a-card_index" */))
const _174320f8 = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _ec732d82 = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _bab16788 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _12c3596f = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _4b7478be = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _360cd459 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _6b40c2c8 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _6b2493c6 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _6aec35c2 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _6ad006c0 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _01744c46 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _e858ba12 = () => interopDefault(import('..\\pages\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_need-a-card_eligibility" */))
const _733fb778 = () => interopDefault(import('..\\pages\\need-a-card\\insurance.vue' /* webpackChunkName: "pages_need-a-card_insurance" */))
const _aa29fcba = () => interopDefault(import('..\\pages\\need-a-card\\insurance-information.vue' /* webpackChunkName: "pages_need-a-card_insurance-information" */))
const _52299c4e = () => interopDefault(import('..\\pages\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_need-a-card_patient-information" */))
const _60f1780a = () => interopDefault(import('..\\pages\\need-a-card\\prescriber-information.vue' /* webpackChunkName: "pages_need-a-card_prescriber-information" */))
const _27e07d80 = () => interopDefault(import('..\\pages\\need-a-card\\select-path.vue' /* webpackChunkName: "pages_need-a-card_select-path" */))
const _c1c86526 = () => interopDefault(import('..\\pages\\need-a-card\\success.vue' /* webpackChunkName: "pages_need-a-card_success" */))
const _1cf39c45 = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _e3a6bbf6 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _5c1a7f8a,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _5511de74,
    children: [{
      path: "",
      component: _5f130b8e,
      name: "have-a-card"
    }, {
      path: "enrollment",
      component: _174320f8,
      name: "have-a-card-enrollment"
    }, {
      path: "success",
      component: _ec732d82,
      name: "have-a-card-success"
    }]
  }, {
    path: "/rejection",
    component: _bab16788,
    name: "rejection"
  }, {
    path: "/thank-you",
    component: _12c3596f,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _4b7478be,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _360cd459,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _6b40c2c8,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _6b2493c6,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _6aec35c2,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _6ad006c0,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _01744c46,
    name: "errors-500"
  }, {
    path: "/need-a-card/eligibility",
    component: _e858ba12,
    name: "need-a-card-eligibility"
  }, {
    path: "/need-a-card/insurance",
    component: _733fb778,
    name: "need-a-card-insurance"
  }, {
    path: "/need-a-card/insurance-information",
    component: _aa29fcba,
    name: "need-a-card-insurance-information"
  }, {
    path: "/need-a-card/patient-information",
    component: _52299c4e,
    name: "need-a-card-patient-information"
  }, {
    path: "/need-a-card/prescriber-information",
    component: _60f1780a,
    name: "need-a-card-prescriber-information"
  }, {
    path: "/need-a-card/select-path",
    component: _27e07d80,
    name: "need-a-card-select-path"
  }, {
    path: "/need-a-card/success",
    component: _c1c86526,
    name: "need-a-card-success"
  }, {
    path: "/patient/patientSearch",
    component: _1cf39c45,
    name: "patient-patientSearch"
  }, {
    path: "/",
    component: _e3a6bbf6,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
